import React, { useState, useEffect } from "react"
import styled, { css } from "styled-components"
import { motion } from "framer-motion"
import useWindowSize from "@hooks/use-window-size"
import ReactPlayer from "react-player"
// import useDimensions from "react-use-dimensions"
import useDimensions from "use-react-dimensions"

import Icon from "../global/icon"
import Button from "../global/button-internal-link"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const BioWrapper = styled.div`
  max-width: 1248px;
  padding: 0 48px;
  margin: 64px auto 96px;
  ${below.tablet`
    margin: 48px auto 72px;
  `};
  ${below.mobile`
  padding: 0 24px;
  margin:  32px auto 40px;
  `}
  h2 {
    margin-bottom: 32px;
  }
  .desktop-button {
    ${below.tablet`
  display: none;
  `}
  }
  .mobile-button {
    display: none;
    ${below.tablet`
  display: block;
  `}
  }
`
const FlexContainer = styled.div`
  display: flex;
  align-items: ${props => props.alignItems || "center"};
  margin: ${props => props.margin || 0};
  justify-content: ${props => props.justifyContent || "flex-start"};

  ${below.tablet`
    flex-direction: column;
  `};
`
const Column = styled.div`
  flex: ${props => props.flex || 0};
  &.fixed-height {
    display: flex;
    flex-direction: column;
    max-height: 725px;
    justify-content: space-between;
    ${below.tablet`
    height: auto;
  `};
  }
`
const Quote = styled.div`
  * {
    display: block;
    font-size: 36px;
    line-height: 44px;
    color: #75808f;
    max-height: auto;
    overflow: hidden;
    ${below.tablet`
    margin-bottom: 16px;
  `};
    ${below.mobile`
    font-size: 28px;
  line-height: 36px;
  `};
  }
  &.long-quote {
    * {
      font-size: 32px;
      line-height: 40px;
      ${below.mobile`
    font-size: 24px;
    line-height: 32px;
    `}
    }
  }
`
const Bio = styled(motion.div)`
  position: relative;
  // margin-bottom: 32px;
  ${below.tablet`
    overflow: hidden;
  `};
  ul {
    margin-bottom: 24px;
  }
  li {
    font-size: 20px;
    line-height: 28px;
    margin-top: 8px;
    :first-child {
      margin-top: 0;
    }
    :before {
      top: 16px;
    }
  }
  p {
    ${below.mobile`
    margin-bottom: 24px;

  `};
  }
  p:last-child {
    margin-bottom: 0;
  }
  overflow: hidden;
`

const ReadMoreButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  &.collapsed {
    ::before {
      content: "";
      pointer-events: none;
      position: absolute;
      top: -90px;
      height: 70px;
      width: 100%;
      z-index: 10;
      background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  ${below.tablet`
    margin-bottom: 80px;
  `};
  ${below.tablet`
    margin-bottom: 48px;
  `};
  div {
    &.caption {
      font-size: 16px;
      line-height: 24px;
      color: #75808f;
      min-width: 84px !important;
    }
  }
  hr {
    width: 100%;
    border: none;
    padding-top: 1px;
    height: 1px;
    border-bottom: 1px solid #75808f;
  }
  svg {
    fill: #75808f;
    width: 12px;
    height: 12px;
  }
`

const MortgageBankerBio = props => {
  // const [ghostRef, ghostSize] = useDimensions()
  const { ref, dimensions } = useDimensions({})
  const [bioHeight, setBioHeight] = useState(96)

  const [expanded, setExpanded] = useState(false)
  const windowSize = useWindowSize()
  useEffect(() => {
    if (windowSize.width > 950) {
      setBioHeight(672)
    } else setBioHeight(96)
  }, [windowSize.width])

  const includeVideo = props.slug === "johnpyne"
  const showReadMoreButon = bioHeight < dimensions.height

  return (
    <BioWrapper>
      <h2>
        {`${
          props.team
            ? "A little more about us."
            : props.slug === "allycain" || props.slug === "sarachandler"
              ? "A little more about the Ally Cain Mortgage Team"
              : "A little more about me."
        }`}
      </h2>
      <FlexContainer alignItems="stretch">
        <Column
          flex="4"
          className={`fixed-height ${includeVideo ? "!justify-start" : ""}`}
        >
          {includeVideo && (
            <div className="relative pt-[56.25%] [&_.react-player]:absolute [&_.react-player]:top-0 [&_.react-player]:left-0">
              <ReactPlayer
                className="react-player"
                url="https://www.youtube.com/watch?v=W06_UqT9aPg"
                width="100%"
                height="100%"
                controls={true}
              />
            </div>
          )}
          <Quote
            className={`${
              props.quote?.length > 156 ? "long-quote" : undefined
            } ${
              includeVideo
                ? "mobile:[&_*]:!leading-[28px] [&_*]:font-variant-numeric--primary [&_*]:!text-[17px] mb-[16px] mt-[32px] [@media(min-width:768px)_and_(max-width:951px)]:[&_*]:!leading-[44px] tablet:[&_*]:!text-[25px] tablet:[&_*]:!text-justify tablet:[&_*]:!-tracking-[0.5px] [@media(min-width:952px)_and_(max-width:1279px)]:[&_*]:!leading-[35px] desktop:mb-auto desktop:[&_*]:!leading-[35px] desktop:[&_*]:!text-[20px] desktop:[&_*]:!-tracking-[0.4px]"
                : ""
            }`}
            dangerouslySetInnerHTML={{
              __html: props.quote,
            }}
          />

          <Button
            linkTo={`/${props.slug}/contact/`}
            buttonText={props.team ? "Contact us" : "Contact me"}
            className="desktop-button mt-auto"
          />
        </Column>
        <Column flex="1" />
        <Column flex="7">
          <Bio
            className={showReadMoreButon ? "mb-[32px]" : ""}
            initial={{ maxHeight: 672 }}
            animate={{ maxHeight: !expanded ? bioHeight : "initial" }}
            dangerouslySetInnerHTML={{
              __html: props.bio,
            }}
          />

          <>
            <div style={{ position: "relative" }}>
              <div
                ref={ref}
                css={`
                  position: absolute;
                  visibility: hidden;
                  z-index: -10;
                  p {
                    font-size: 24px;
                    line-height: 32px;
                    ${below.mobile`margin-bottom: 24px; font-size: 18px; line-height: 24px;`};
                  }
                  p:last-of-type {
                    margin-bottom: 0;
                  }
                `}
                dangerouslySetInnerHTML={{
                  __html: props.bio,
                }}
              />
            </div>
          </>

          {bioHeight < dimensions.height && (
            <ReadMoreButton
              className={!expanded ? "collapsed" : undefined}
              onClick={() => setExpanded(!expanded)}
            >
              <div style={{ marginRight: 8 }} className="caption">
                {!expanded ? "Read more" : "Hide Bio"}
              </div>
              <hr />
              <div style={{ margin: "auto 12px", display: "flex" }}>
                <Icon icon={!expanded ? "openDrawer" : "closeDrawer"} />
              </div>
            </ReadMoreButton>
          )}
          <Button
            linkTo={`/${props.slug}/contact/`}
            buttonText={props.team ? "Contact us" : "Contact me"}
            className="mobile-button"
          />
        </Column>
      </FlexContainer>
    </BioWrapper>
  )
}

export default MortgageBankerBio
